import {
  ID__toString_impl_y5caka34b933o3jkvt9 as ID__toString_impl_y5caka,
  ChildPlacement1fdgqwhgo48yv as ChildPlacement,
  IDknm0szoty74n as ID,
  IDqqik72jjbpsn as ID_0,
  ID1lyj7m2ox8cp5 as ID_1,
  ID1z61wlmtvxrjn as ID_2,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  listOfvhqybd2zx248 as listOf,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get__id1elsu38391a1o as get__id,
  get__id2ft65q2wfav1v as get__id_0,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  asSequence2phdjljfh9jhx as asSequence,
  sorted354mfsiv4s7x5 as sorted,
  sortedWith2csnbbb21k0lg as sortedWith,
  plus310ted5e4i90h as plus,
  toSet2orjxp16sotqu as toSet,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  mapsbvh18eqox7a as map,
  toSet2morh2kqexfa2 as toSet_0,
  flatMap1gb3cjy1dqv3d as flatMap,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { compareBy2697bq0ffft96 as compareBy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  CareLocationProgrameuu05ugy00sb as CareLocationProgram,
  ID3lnbkn76l7dgd as ID_3,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import {
  Cents1lsbs5l1tlgw as Cents,
  Companion_instance1c40ds0jrup2e as Companion_instance,
  Cents__plus_impl_qsv4s83hvgnvnlu2892 as Cents__plus_impl_qsv4s8,
  Cents__toString_impl_ko5hxm1a9pwstsznn43 as Cents__toString_impl_ko5hxm,
} from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import {
  format2n4cpzximuj7a as format,
  Companion_getInstance3h03aipe2gus4 as Companion_getInstance,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints19w9rda6g3rqz as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  subtext2yjmf1ok7kb40 as subtext,
  text189ciz0cnr32o as text,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  DangerSemantic_getInstance1xd9zwrvs99lp as DangerSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { keyValue1ck7xpd7fxylw as keyValue } from './view-utilities.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { weight31wqab1913ly4 as weight } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  Companion_instance3avuh2je008a9 as Companion_instance_0,
  AttendanceCellState_NotScheduled_getInstance3itq8wmesmvbz as AttendanceCellState_NotScheduled_getInstance,
  AttendanceEntryBox2fe5zhsdvgxaf as AttendanceEntryBox,
} from './attendanceStyling.mjs';
import { MenuButton27en4jjgdkozz as MenuButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/MenuButton.commonHtml.mjs';
import {
  MenuButton$_get_enabled_$ref_o66tn02bouexjmaklml as MenuButton$_get_enabled_$ref_o66tn0,
  MenuButton$_set_enabled_$ref_647cow1po0j8ztqws82 as MenuButton$_set_enabled_$ref_647cow,
} from '../attendance/attendanceGrid.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { Companion_getInstance29ka8gqgdrya1 as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/ScreenTransitions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Fixedsogarmaf088q as Fixed,
  TableColumn199vk8dy8jaqx as TableColumn,
  tableWithSticky1958em9ua7p76 as tableWithSticky,
} from './table.mjs';
import {
  Align_Stretch_getInstance2huaa6rbagugp as Align_Stretch_getInstance,
  Align_Center_getInstance366ihr7rj12mu as Align_Center_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Companion_getInstance2lv012sehjn6z as Companion_getInstance_1 } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/format/LocalDateFormat.mjs';
import { Companion_getInstance3rwcbkvzrbmti as Companion_getInstance_2 } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/format/YearMonthFormat.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { char1r4ssccmdfesy as char } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/format/DateTimeFormatBuilder.mjs';
import { Padding_NONE_getInstance3hrh9czbcdldi as Padding_NONE_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/format/DateTimeFormat.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_weekdayFormat() {
  _init_properties_remittanceBreakdownGrid_kt__1hags7();
  return weekdayFormat;
}
var weekdayFormat;
function get_menuDateFormat() {
  _init_properties_remittanceBreakdownGrid_kt__1hags7();
  return menuDateFormat;
}
var menuDateFormat;
function RemittanceTableData$Companion$calculate$lambda(it) {
  return it.forDate_1;
}
function RemittanceTableData$Companion$calculate$lambda_0(it) {
  return ID__toString_impl_y5caka(it.location_1);
}
function RemittanceTableData$Companion$calculate$lambda_1(it) {
  return it.childName_1;
}
var ForPlacementClass;
function ForPlacement() {
  if (ForPlacementClass === VOID) {
    class $ {
      constructor(placement, perDate) {
        this.placement_1 = placement;
        this.perDate_1 = perDate;
        var tmp = this;
        var tmp0 = this.perDate_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlin.collections.count' call
          var tmp_0;
          if (isInterface(tmp0, Collection())) {
            tmp_0 = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = 0;
            break $l$block;
          }
          var count = 0;
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            var tmp_1;
            var tmp1_safe_receiver = element == null ? null : element.attendance_1;
            if (!((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_billedTime_8fk3ac_k$()) == null)) {
              var tmp3_safe_receiver = element == null ? null : element.attendance_1;
              var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.case_1;
              tmp_1 = (tmp4_safe_receiver == null ? null : tmp4_safe_receiver.closureReason_1) == null;
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              count = count + 1 | 0;
              checkCountOverflow(count);
            }
          }
          tmp$ret$0 = count;
        }
        tmp.expectedAttendanceDays_1 = tmp$ret$0;
        var tmp_2 = this;
        var tmp0_0 = this.perDate_1;
        var tmp$ret$2;
        $l$block_0: {
          // Inline function 'kotlin.collections.count' call
          var tmp_3;
          if (isInterface(tmp0_0, Collection())) {
            tmp_3 = tmp0_0.isEmpty_y1axqb_k$();
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp$ret$2 = 0;
            break $l$block_0;
          }
          var count_0 = 0;
          var _iterator__ex2g4s_0 = tmp0_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
            var tmp1_safe_receiver_0 = element_0 == null ? null : element_0.attendance_1;
            var tmp2_safe_receiver = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.case_1;
            if ((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.atLeastPartialAttendance_1) === true) {
              count_0 = count_0 + 1 | 0;
              checkCountOverflow(count_0);
            }
          }
          tmp$ret$2 = count_0;
        }
        tmp_2.actuallyAttendedDays_1 = tmp$ret$2;
        this.attendanceRatio_1 = this.expectedAttendanceDays_1 === 0 ? 1.0 : this.actuallyAttendedDays_1 / this.expectedAttendanceDays_1;
      }
      toString() {
        return 'ForPlacement(placement=' + this.placement_1.toString() + ', perDate=' + toString(this.perDate_1) + ')';
      }
      hashCode() {
        var result = this.placement_1.hashCode();
        result = imul(result, 31) + hashCode(this.perDate_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ForPlacement()))
          return false;
        if (!this.placement_1.equals(other.placement_1))
          return false;
        if (!equals(this.perDate_1, other.perDate_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ForPlacement');
    ForPlacementClass = $;
  }
  return ForPlacementClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      *calculate_mx8h7j_k$(items, $completion) {
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_0 = get_currentSessionNotNull();
        var tmp = (yield* await_0(this_0, $completion)).api_1.get_childPlacement_o77pq_k$();
        // Inline function 'com.lightningkite.services.database.condition' call
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_0 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
        var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        // Inline function 'kotlin.let' call
        var it = new (DataClassPathSelf())(tmp$ret$3);
        var tmp_1 = get__id(it);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
        var _iterator__ex2g4s = items.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$7 = new (ID())(item.placement_1);
          destination.add_utx5q5_k$(tmp$ret$7);
        }
        var tmp$ret$1 = xDataClassPathInsideSet(tmp_1, destination);
        var placements = yield* tmp.query_o986pg_k$(new (Query())(tmp$ret$1), $completion);
        // Inline function 'kotlin.collections.groupBy' call
        // Inline function 'kotlin.collections.groupByTo' call
        var destination_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        var _iterator__ex2g4s_0 = items.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s_0.next_20eer_k$();
          var key = new (ID())(element.placement_1);
          // Inline function 'kotlin.collections.getOrPut' call
          var value = destination_0.get_wei43m_k$(key);
          var tmp_2;
          if (value == null) {
            var answer = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            destination_0.put_4fpzoq_k$(key, answer);
            tmp_2 = answer;
          } else {
            tmp_2 = value;
          }
          var list = tmp_2;
          list.add_utx5q5_k$(element);
        }
        var grouped = destination_0;
        var tmp_3 = asSequence(items);
        var dates = sorted(toSet_0(map(tmp_3, RemittanceTableData$Companion$calculate$lambda)));
        var tmp_4 = RemittanceTableData$Companion$calculate$lambda_0;
        // Inline function 'kotlin.collections.map' call
        var this_1 = sortedWith(placements, compareBy([tmp_4, RemittanceTableData$Companion$calculate$lambda_1]));
        // Inline function 'kotlin.collections.mapTo' call
        var destination_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
        var _iterator__ex2g4s_1 = this_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
          var item_0 = _iterator__ex2g4s_1.next_20eer_k$();
          var tmp0_elvis_lhs = grouped.get_wei43m_k$(new (ID())(item_0._id_1));
          var tmp_5;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.collections.listOf' call
            tmp_5 = emptyList();
          } else {
            tmp_5 = tmp0_elvis_lhs;
          }
          var some = tmp_5;
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_2 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(dates, 10));
          var _iterator__ex2g4s_2 = dates.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
            var item_1 = _iterator__ex2g4s_2.next_20eer_k$();
            // Inline function 'kotlin.collections.find' call
            var tmp$ret$21;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s_3 = some.iterator_jk1svi_k$();
              while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
                var element_0 = _iterator__ex2g4s_3.next_20eer_k$();
                if (element_0.forDate_1.equals(item_1)) {
                  tmp$ret$21 = element_0;
                  break $l$block;
                }
              }
              tmp$ret$21 = null;
            }
            var tmp$ret$19 = tmp$ret$21;
            destination_2.add_utx5q5_k$(tmp$ret$19);
          }
          var tmp$ret$15 = new (ForPlacement())(item_0, destination_2);
          destination_1.add_utx5q5_k$(tmp$ret$15);
        }
        var forPlacements = destination_1;
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_2 = get_currentSessionNotNull();
        var tmp_6 = (yield* await_0(this_2, $completion)).api_1.get_careLocationPrograms_g0oima_k$();
        // Inline function 'com.lightningkite.services.database.condition' call
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_7 = serializerOrContextual(createKType(getKClass(CareLocationProgram()), arrayOf([]), false));
        var tmp$ret$26 = isInterface(tmp_7, KSerializer()) ? tmp_7 : THROW_CCE();
        // Inline function 'kotlin.let' call
        var it_0 = new (DataClassPathSelf())(tmp$ret$26);
        var tmp_8 = get__id_0(it_0);
        // Inline function 'kotlin.collections.flatMap' call
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination_3 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s_4 = placements.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
          var element_1 = _iterator__ex2g4s_4.next_20eer_k$();
          var list_0 = element_1.schedule_1.get_programs_mo5naw_k$();
          addAll(destination_3, list_0);
        }
        var tmp_9 = destination_3;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_4 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(items, 10));
        var _iterator__ex2g4s_5 = items.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_5.hasNext_bitz1p_k$()) {
          var item_2 = _iterator__ex2g4s_5.next_20eer_k$();
          var tmp$ret$34 = new (ID_3())(item_2.program_1);
          destination_4.add_utx5q5_k$(tmp$ret$34);
        }
        var tmp$ret$24 = xDataClassPathInsideSet(tmp_8, toSet(plus(tmp_9, destination_4)));
        // Inline function 'kotlin.collections.associateBy' call
        var this_3 = yield* tmp_6.query_o986pg_k$(new (Query())(tmp$ret$24), $completion);
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_3, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination_5 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
        var _iterator__ex2g4s_6 = this_3.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_6.hasNext_bitz1p_k$()) {
          var element_2 = _iterator__ex2g4s_6.next_20eer_k$();
          var tmp$ret$37 = new (ID_3())(element_2._id_1);
          destination_5.put_4fpzoq_k$(tmp$ret$37, element_2);
        }
        return new (RemittanceTableData())(dates, forPlacements, destination_5);
      }
    }
    initMetadataForCompanion($, VOID, VOID, [1]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_1;
function Companion_getInstance_3() {
  return Companion_instance_1;
}
function RemittanceTableData$render$lambda(it) {
  return new (Cents())(it.price_1);
}
function RemittanceTableData$render$lambda_0($this$tableWithSticky, it) {
  return $this$tableWithSticky;
}
function RemittanceTableData$render$lambda_1($this$TableColumn) {
  return 'Placement';
}
function RemittanceTableData$render$lambda_2($this$TableColumn) {
  return 'Grand Total';
}
function RemittanceTableData$render$lambda$lambda$lambda(it) {
  return it.name_1;
}
function RemittanceTableData$render$lambda_3($this$TableColumn) {
  return 'Total';
}
function RemittanceTableData$render$lambda_4($date) {
  return ($this$TableColumn) => format($date, get_weekdayFormat()) + ' ' + $date.day_1;
}
function RemittanceTableData$render$lambda_5(this$0, $dateIndex, $show) {
  return ($this$TableColumn) => {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = this$0.placements_1;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp0_safe_receiver = element.perDate_1.get_c1px32_k$($dateIndex);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp_0 = $show(tmp0_safe_receiver);
        tmp = tmp_0 == null ? null : tmp_0.inCents_1;
      }
      var tmp_1 = tmp;
      var tmp0_safe_receiver_0 = tmp_1 == null ? null : new (Cents())(tmp_1);
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.add_utx5q5_k$(tmp0_safe_receiver_0);
      }
    }
    // Inline function 'kotlin.collections.fold' call
    var accumulator = new (Cents())(Companion_instance.get_cents_3bbzqx_k$(0));
    var _iterator__ex2g4s_0 = destination.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
      var tmp0_0 = accumulator.inCents_1;
      var p1 = element_0.inCents_1;
      accumulator = new (Cents())(Cents__plus_impl_qsv4s8(tmp0_0, p1));
    }
    var tmp$ret$8 = accumulator.inCents_1;
    return Cents__toString_impl_ko5hxm(tmp$ret$8);
  };
}
function RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceVoided_7coapm_k$();
}
function RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_0($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceDayAttendanceLabel_y52ora_k$();
}
function RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_1($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceDayProgramLabel_7icdid_k$();
}
function RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_2($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceCostOfCareLabel_pxj9qw_k$();
}
function RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_3($employer) {
  return ($this$inlineLabel) => {
    var tmp0_safe_receiver = $this$inlineLabel.invoke_r7m7el_k$($this$inlineLabel.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$().get_6ueaa7_k$(new (ID_0())($employer.employer_1)));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  };
}
function RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_4($label) {
  return ($this$invoke) => $label($this$invoke);
}
function RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_5($grant) {
  return ($this$inlineLabel) => {
    var tmp0_safe_receiver = $this$inlineLabel.invoke_r7m7el_k$($this$inlineLabel.invoke_r7m7el_k$(get_currentSessionNotNull()).get_grants_dxrzz4_k$().get_6ueaa7_k$(new (ID_1())($grant.grant_1)));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  };
}
function RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_6($label) {
  return ($this$invoke) => $label($this$invoke);
}
function RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_7($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceTcgPaysLabel_z6hcxk_k$();
}
function RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_8($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceFamilyPaysLabel_f1jlxa_k$();
}
function RemittanceTableData$render$lambda$lambda$lambda$lambda($next, $placement, this$0) {
  return ($this$swap) => {
    var day = $next;
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = sizeConstraints($this$swap, get_rem(20));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_1 = themed(element, LabelGapSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    this_1.willAddChild_hz2iwc_k$(element_0);
    element_0.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    var this_2 = get_bold(element_0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (TextView())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    this_2.willAddChild_hz2iwc_k$(element_1);
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
    var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
    element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$($placement).placement_1.childName_1);
    element_1.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_1);
    subtext(element_0, format(day.forDate_1, get_menuDateFormat()));
    element_0.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_0);
    if (!(day.voided_1 == null)) {
      // Inline function 'com.lightningkite.kiteui.views.danger' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_3 = themed(element, DangerSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (TextView())(this_3.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      this_3.willAddChild_hz2iwc_k$(element_2);
      var tmp_2 = KMutableProperty0();
      var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_2);
      var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_2));
      element_2.invoke_bnq13k_k$(tmp_4, RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda);
      element_2.onStartup_vrxh3i_k$();
      this_3.addChild_2qpft2_k$(element_2);
    }
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (Separator())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    element.willAddChild_hz2iwc_k$(element_3);
    element_3.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_3);
    var tmp_5 = RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_0;
    keyValue(element, tmp_5, ($this$keyValue) => day.attendance_1.get_massachusettsAttendanceCode_3eo4hh_k$().get_displayName_sscnb0_k$());
    var tmp_6 = RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_1;
    keyValue(element, tmp_6, ($this$keyValue) => {
      var tmp0_safe_receiver = this$0.programs_1.get_wei43m_k$(new (ID_3())(day.program_1));
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
      return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    });
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = new (Separator())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    element.willAddChild_hz2iwc_k$(element_4);
    element_4.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_4);
    var tmp_7 = RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_2;
    keyValue(element, tmp_7, ($this$keyValue) => Cents__toString_impl_ko5hxm(day.price_1));
    var _iterator__ex2g4s = day.employerContributions_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var employer = _iterator__ex2g4s.next_20eer_k$();
      // Inline function 'org.thecommunitygroupinc.cares.views.components.inlineLabel' call
      var label = RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_3(employer);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_5 = new (RowOrCol())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_5);
      element.willAddChild_hz2iwc_k$(element_5);
      element_5.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_4 = sizeConstraints(get_centered(element_5), VOID, VOID, VOID, VOID, VOID, get_rem(10));
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_6 = new (TextView())(this_4.get_context_h02k06_k$());
      ensureOutermostElement(element_6);
      this_4.willAddChild_hz2iwc_k$(element_6);
      element_6.set_themeChoice_py59um_k$(element_6.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
      var tmp_8 = KMutableProperty0();
      var tmp_9 = TextView$_get_content_$ref_4pzcwl(element_6);
      var tmp_10 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb(element_6));
      element_6.invoke_bnq13k_k$(tmp_10, RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_4(label));
      element_6.onStartup_vrxh3i_k$();
      this_4.addChild_2qpft2_k$(element_6);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      var this_5 = get_centered(element_5);
      var $this$inlineLabel = weight(this_5, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_6 = themed($this$inlineLabel, LabelGapSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_7 = new (RowOrCol())(this_6.get_context_h02k06_k$());
      ensureOutermostElement(element_7);
      this_6.willAddChild_hz2iwc_k$(element_7);
      element_7.set_vertical_nuap32_k$(true);
      text(element_7, Cents__toString_impl_ko5hxm(employer.amount_1));
      // Inline function 'kotlin.takeUnless' call
      var this_7 = new (Cents())(employer.administrativeCharge_1);
      var tmp_11;
      if (!(this_7.inCents_1 === Companion_instance.get_cents_3bbzqx_k$(0))) {
        tmp_11 = this_7;
      } else {
        tmp_11 = null;
      }
      var tmp_12 = tmp_11;
      var tmp0_safe_receiver = tmp_12 == null ? null : tmp_12.inCents_1;
      var tmp_13 = tmp0_safe_receiver;
      if ((tmp_13 == null ? null : new (Cents())(tmp_13)) == null)
        null;
      else {
        var tmp_14 = tmp0_safe_receiver;
        // Inline function 'kotlin.let' call
        var it = (tmp_14 == null ? null : new (Cents())(tmp_14)).inCents_1;
        subtext(element_7, 'plus ' + Cents__toString_impl_ko5hxm(it) + ' admin charge');
      }
      element_7.onStartup_vrxh3i_k$();
      this_6.addChild_2qpft2_k$(element_7);
      element_5.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_5);
    }
    var _iterator__ex2g4s_0 = day.grantContributions_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var grant = _iterator__ex2g4s_0.next_20eer_k$();
      // Inline function 'org.thecommunitygroupinc.cares.views.components.inlineLabel' call
      var label_0 = RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_5(grant);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_8 = new (RowOrCol())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_8);
      element.willAddChild_hz2iwc_k$(element_8);
      element_8.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_8 = sizeConstraints(get_centered(element_8), VOID, VOID, VOID, VOID, VOID, get_rem(10));
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_9 = new (TextView())(this_8.get_context_h02k06_k$());
      ensureOutermostElement(element_9);
      this_8.willAddChild_hz2iwc_k$(element_9);
      element_9.set_themeChoice_py59um_k$(element_9.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
      var tmp_15 = KMutableProperty0();
      var tmp_16 = TextView$_get_content_$ref_4pzcwl(element_9);
      var tmp_17 = getPropertyCallableRef('content', 0, tmp_15, tmp_16, TextView$_set_content_$ref_pketfb(element_9));
      element_9.invoke_bnq13k_k$(tmp_17, RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_6(label_0));
      element_9.onStartup_vrxh3i_k$();
      this_8.addChild_2qpft2_k$(element_9);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      var this_9 = get_centered(element_8);
      var $this$inlineLabel_0 = weight(this_9, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_10 = themed($this$inlineLabel_0, LabelGapSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_10 = new (RowOrCol())(this_10.get_context_h02k06_k$());
      ensureOutermostElement(element_10);
      this_10.willAddChild_hz2iwc_k$(element_10);
      element_10.set_vertical_nuap32_k$(true);
      text(element_10, Cents__toString_impl_ko5hxm(grant.amount_1));
      // Inline function 'kotlin.takeUnless' call
      var this_11 = new (Cents())(grant.administrativeCharge_1);
      var tmp_18;
      if (!(this_11.inCents_1 === Companion_instance.get_cents_3bbzqx_k$(0))) {
        tmp_18 = this_11;
      } else {
        tmp_18 = null;
      }
      var tmp_19 = tmp_18;
      var tmp0_safe_receiver_0 = tmp_19 == null ? null : tmp_19.inCents_1;
      var tmp_20 = tmp0_safe_receiver_0;
      if ((tmp_20 == null ? null : new (Cents())(tmp_20)) == null)
        null;
      else {
        var tmp_21 = tmp0_safe_receiver_0;
        // Inline function 'kotlin.let' call
        var it_0 = (tmp_21 == null ? null : new (Cents())(tmp_21)).inCents_1;
        subtext(element_10, 'plus ' + Cents__toString_impl_ko5hxm(it_0) + ' admin charge');
      }
      element_10.onStartup_vrxh3i_k$();
      this_10.addChild_2qpft2_k$(element_10);
      element_8.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_8);
    }
    var tmp_22 = get_bold(element);
    var tmp_23 = RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_7;
    keyValue(tmp_22, tmp_23, ($this$keyValue) => Cents__toString_impl_ko5hxm(day.totalContributions_1));
    var tmp_24 = RemittanceTableData$render$lambda$lambda$lambda$lambda$lambda_8;
    keyValue(element, tmp_24, ($this$keyValue) => Cents__toString_impl_ko5hxm(day.paidByFamily_1));
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  };
}
function RemittanceTableData$render$lambda_6($dateIndex, $show, this$0) {
  return ($this$TableColumn, placement) => {
    var day = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(placement).perDate_1.get_c1px32_k$($dateIndex));
    // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
    var this_0 = dynamicThemed($this$TableColumn, ($this$dynamicThemed) => {
      var tmp0_safe_receiver = $this$dynamicThemed.invoke_r7m7el_k$(day);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = Companion_instance_0.of_fosl41_k$(tmp0_safe_receiver.attendance_1.case_1);
      }
      var tmp1_elvis_lhs = tmp;
      return new (AttendanceEntryBox())(tmp1_elvis_lhs == null ? AttendanceCellState_NotScheduled_getInstance() : tmp1_elvis_lhs);
    });
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (MenuButton())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    var tmp = KMutableProperty0();
    var tmp_0 = MenuButton$_get_enabled_$ref_o66tn0(element);
    var tmp_1 = getPropertyCallableRef('enabled', 0, tmp, tmp_0, MenuButton$_set_enabled_$ref_647cow(element));
    element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$(day) == null));
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    var this_1 = get_centered(element);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (TextView())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    this_1.willAddChild_hz2iwc_k$(element_0);
    var tmp_2 = KMutableProperty0();
    var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_0);
    var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_0));
    element_0.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
      var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(day);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp_0 = $show(tmp0_safe_receiver);
        tmp = tmp_0 == null ? null : tmp_0.inCents_1;
      }
      var tmp1_safe_receiver = tmp;
      var tmp_1;
      var tmp_2 = tmp1_safe_receiver;
      if ((tmp_2 == null ? null : new (Cents())(tmp_2)) == null) {
        tmp_1 = null;
      } else {
        tmp_1 = Cents__toString_impl_ko5hxm(tmp1_safe_receiver);
      }
      var tmp2_elvis_lhs = tmp_1;
      return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
    });
    element_0.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_0);
    element.requireClick_1 = true;
    element.opensMenu_gggyad_k$(($this$opensMenu) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
      // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (SwapView())($this$opensMenu.get_context_h02k06_k$());
      ensureOutermostElement(element);
      $this$opensMenu.willAddChild_hz2iwc_k$(element);
      // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
      var this_0 = element;
      var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      var alreadySwapping = {_v: false};
      reactive(this_0, 8, ($this$reactive) => {
        var c = ensureNotNull($this$reactive.invoke_r7m7el_k$(day));
        queue.add_utx5q5_k$(c);
        var tmp;
        if (alreadySwapping._v) {
          return Unit_instance;
        }
        alreadySwapping._v = true;
        $l$loop: while (true) {
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!!queue.isEmpty_y1axqb_k$()) {
            break $l$loop;
          }
          var next = queue.removeAt_6niowx_k$(0);
          try {
            var tmp_0 = Companion_getInstance_0().Fade_1;
            this_0.swap_26x94b_k$(tmp_0, RemittanceTableData$render$lambda$lambda$lambda$lambda(next, placement, this$0));
          } catch ($p) {
            if ($p instanceof Exception()) {
              var e = $p;
              report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString_0(next), e), 'SwapView.swapping');
            } else {
              throw $p;
            }
          }
        }
        alreadySwapping._v = false;
        return Unit_instance;
      });
      element.onStartup_vrxh3i_k$();
      $this$opensMenu.addChild_2qpft2_k$(element);
      return Unit_instance;
    });
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  };
}
var RemittanceTableDataClass;
function RemittanceTableData() {
  if (RemittanceTableDataClass === VOID) {
    class $ {
      constructor(dates, placements, programs) {
        this.dates_1 = dates;
        this.placements_1 = placements;
        this.programs_1 = programs;
      }
      render_b3nvws_k$(writer, show) {
        var tmp = _Constant___init__impl__v45mub(this.placements_1);
        var tmp_0 = RemittanceTableData$render$lambda_0;
        var tmp_1 = get_rem(6);
        var tmp_2 = RemittanceTableData$render$lambda_1;
        var tmp_3 = new (Fixed())(get_rem(14));
        var tmp_4 = RemittanceTableData$render$lambda_2;
        var tmp_5 = _Constant___init__impl__v45mub(listOf(new (TableColumn())(tmp_2, tmp_3, VOID, tmp_4, VOID, ($this$TableColumn, placement) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())($this$TableColumn.get_context_h02k06_k$());
          ensureOutermostElement(element);
          $this$TableColumn.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_gap_jwjroq_k$(get_px(0));
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
          element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(placement).placement_1.childName_1);
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          element.willAddChild_hz2iwc_k$(element_1);
          element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
          var tmp_2 = KMutableProperty0();
          var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
          var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
          element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
            var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$().get_6ueaa7_k$(new (ID_2())($this$invoke.invoke_r7m7el_k$(placement).placement_1.location_1)));
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
            return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
          });
          element_1.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_2 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_2);
          element.willAddChild_hz2iwc_k$(element_2);
          element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
          var tmp_5 = KMutableProperty0();
          var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_2);
          var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_2));
          element_2.invoke_bnq13k_k$(tmp_7, ($this$invoke) => {
            // Inline function 'kotlin.collections.mapNotNull' call
            var tmp0 = $this$invoke.invoke_r7m7el_k$(placement).placement_1.schedule_1.get_programs_mo5naw_k$();
            // Inline function 'kotlin.collections.mapNotNullTo' call
            var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              var it = element.raw_1;
              var tmp0_safe_receiver = this.programs_1.get_wei43m_k$(new (ID_3())(it));
              if (tmp0_safe_receiver == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                destination.add_utx5q5_k$(tmp0_safe_receiver);
              }
            }
            var tmp = destination;
            return joinToString(tmp, VOID, VOID, VOID, VOID, VOID, RemittanceTableData$render$lambda$lambda$lambda);
          });
          element_2.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_2);
          element.onStartup_vrxh3i_k$();
          $this$TableColumn.addChild_2qpft2_k$(element);
          return Unit_instance;
        })));
        var tmp_6 = RemittanceTableData$render$lambda_3;
        var tmp_7 = new (Fixed())(get_rem(7));
        var tmp_8 = ($this$TableColumn) => {
          var tmp = asSequence(this.placements_1);
          var tmp0 = flatMap(tmp, (it) => {
            // Inline function 'kotlin.collections.mapNotNull' call
            var tmp0 = it.perDate_1;
            // Inline function 'kotlin.collections.mapNotNullTo' call
            var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              var tmp;
              if (element == null) {
                tmp = null;
              } else {
                // Inline function 'kotlin.let' call
                var tmp_0 = show(element);
                tmp = tmp_0 == null ? null : tmp_0.inCents_1;
              }
              var tmp_1 = tmp;
              var tmp0_safe_receiver = tmp_1 == null ? null : new (Cents())(tmp_1);
              if (tmp0_safe_receiver == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                destination.add_utx5q5_k$(tmp0_safe_receiver);
              }
            }
            return destination;
          });
          // Inline function 'kotlin.sequences.fold' call
          var accumulator = new (Cents())(Companion_instance.get_cents_3bbzqx_k$(0));
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            var tmp0_0 = accumulator.inCents_1;
            var p1 = element.inCents_1;
            accumulator = new (Cents())(Cents__plus_impl_qsv4s8(tmp0_0, p1));
          }
          var tmp$ret$32 = accumulator.inCents_1;
          return Cents__toString_impl_ko5hxm(tmp$ret$32);
        };
        var tmp_9 = listOf(new (TableColumn())(tmp_6, tmp_7, VOID, tmp_8, VOID, ($this$TableColumn, placement) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())($this$TableColumn.get_context_h02k06_k$());
          ensureOutermostElement(element);
          $this$TableColumn.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            // Inline function 'kotlin.collections.mapNotNull' call
            var tmp0 = $this$invoke.invoke_r7m7el_k$(placement).perDate_1;
            // Inline function 'kotlin.collections.mapNotNullTo' call
            var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              var tmp;
              if (element == null) {
                tmp = null;
              } else {
                // Inline function 'kotlin.let' call
                var tmp_0 = show(element);
                tmp = tmp_0 == null ? null : tmp_0.inCents_1;
              }
              var tmp_1 = tmp;
              var tmp0_safe_receiver = tmp_1 == null ? null : new (Cents())(tmp_1);
              if (tmp0_safe_receiver == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                destination.add_utx5q5_k$(tmp0_safe_receiver);
              }
            }
            // Inline function 'kotlin.collections.fold' call
            var accumulator = new (Cents())(Companion_instance.get_cents_3bbzqx_k$(0));
            var _iterator__ex2g4s_0 = destination.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
              var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
              var tmp0_0 = accumulator.inCents_1;
              var p1 = element_0.inCents_1;
              accumulator = new (Cents())(Cents__plus_impl_qsv4s8(tmp0_0, p1));
            }
            var tmp$ret$45 = accumulator.inCents_1;
            return Cents__toString_impl_ko5hxm(tmp$ret$45);
          });
          element.onStartup_vrxh3i_k$();
          $this$TableColumn.addChild_2qpft2_k$(element);
          return Unit_instance;
        }));
        // Inline function 'kotlin.collections.mapIndexed' call
        var this_0 = this.dates_1;
        // Inline function 'kotlin.collections.mapIndexedTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var index = 0;
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          var dateIndex = checkIndexOverflow(_unary__edvuaz);
          var tmp0_sizing = new (Fixed())(get_rem(5));
          var tmp1_verticalAlign = Align_Stretch_getInstance();
          var tmp2_headerAlignment = Align_Center_getInstance();
          var tmp_10 = RemittanceTableData$render$lambda_4(item);
          var tmp_11 = RemittanceTableData$render$lambda_5(this, dateIndex, show);
          var tmp$ret$49 = new (TableColumn())(tmp_10, tmp0_sizing, tmp1_verticalAlign, tmp_11, tmp2_headerAlignment, RemittanceTableData$render$lambda_6(dateIndex, show, this));
          destination.add_utx5q5_k$(tmp$ret$49);
        }
        return tableWithSticky(writer, new (Constant())(tmp), tmp_0, tmp_1, new (Constant())(tmp_5), new (Constant())(_Constant___init__impl__v45mub(plus(tmp_9, destination))));
      }
      render$default_9uggcv_k$(writer, show, $super) {
        var tmp;
        if (show === VOID) {
          tmp = RemittanceTableData$render$lambda;
        } else {
          tmp = show;
        }
        show = tmp;
        return $super === VOID ? this.render_b3nvws_k$(writer, show) : $super.render_b3nvws_k$.call(this, writer, show);
      }
      toString() {
        return 'RemittanceTableData(dates=' + toString(this.dates_1) + ', placements=' + toString(this.placements_1) + ', programs=' + toString(this.programs_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.dates_1);
        result = imul(result, 31) + hashCode(this.placements_1) | 0;
        result = imul(result, 31) + hashCode(this.programs_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RemittanceTableData()))
          return false;
        if (!equals(this.dates_1, other.dates_1))
          return false;
        if (!equals(this.placements_1, other.placements_1))
          return false;
        if (!equals(this.programs_1, other.programs_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'RemittanceTableData');
    RemittanceTableDataClass = $;
  }
  return RemittanceTableDataClass;
}
function weekdayFormat$lambda($this$Format) {
  _init_properties_remittanceBreakdownGrid_kt__1hags7();
  $this$Format.dayOfWeek_tn8lxa_k$(Companion_getInstance_1().ENGLISH_ABBREVIATED_1);
  return Unit_instance;
}
function menuDateFormat$lambda($this$Format) {
  _init_properties_remittanceBreakdownGrid_kt__1hags7();
  $this$Format.dayOfWeek_tn8lxa_k$(Companion_getInstance_1().ENGLISH_ABBREVIATED_1);
  $this$Format.chars_pe6iqb_k$(', ');
  $this$Format.monthName_asbkgr_k$(Companion_getInstance_2().ENGLISH_ABBREVIATED_1);
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.day_pu15qg_k$(Padding_NONE_getInstance());
  return Unit_instance;
}
var properties_initialized_remittanceBreakdownGrid_kt_n985rt;
function _init_properties_remittanceBreakdownGrid_kt__1hags7() {
  if (!properties_initialized_remittanceBreakdownGrid_kt_n985rt) {
    properties_initialized_remittanceBreakdownGrid_kt_n985rt = true;
    var tmp = Companion_getInstance();
    weekdayFormat = tmp.Format_rqffoz_k$(weekdayFormat$lambda);
    var tmp_0 = Companion_getInstance();
    menuDateFormat = tmp_0.Format_rqffoz_k$(menuDateFormat$lambda);
  }
}
//region block: init
Companion_instance_1 = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance_1 as Companion_instance177q6f44m9gy2,
};
//endregion

//# sourceMappingURL=remittanceBreakdownGrid.mjs.map
